// extracted by mini-css-extract-plugin
export default {"tagsLayout":"Tags_tagsLayout__YaRgM","tagsOuterContent":"Tags_tagsOuterContent__Hvbjo","tagsContent":"Tags_tagsContent__iOO4b"};